<div [formGroup]="parentForm" class="container">
    <div>
        <label class={{labelClass}}>{{ labelName }}</label>
    </div>
    <div>
        <input type="tel"
        #phoneInputEl
        class={{inputClass}}
        formControlName="phone"
        id="phone"
        class="input"
        [placeholder]="placeholder"
        (keyup)="checkPhone()"
        (focus)="focus()"
        onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" />
    </div>
</div>
